module.exports = __webpack_public_path__ + "static/media/filter_expanded.99cfa8f5.svg";